import { SecurityWarningIcon } from '@hugeicons-pro/core-solid-rounded';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { HStack } from '@/components/gluestack/hstack';
import { Text } from '@/components/gluestack/text';
import { VStack } from '@/components/gluestack/vstack';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';

interface INewAccountNoticeProps {
  userName: string;
}

export function NewAccountNotice({ userName }: INewAccountNoticeProps) {
  const { t } = useTranslation();

  return (
    <VStack className="w-full max-w-[640px] items-center gap-1 self-center px-4 pb-5 pt-4">
      <HStack className="items-center gap-1.5">
        <HugeIconsWrapper icon={SecurityWarningIcon} size={18} className="color-warning-500" />
        <Text size="md" bold className="shrink text-center text-typography-700">
          {t('messages.newAccountNotice.title', { name: userName })}
        </Text>
      </HStack>
      <Text size="xs" className="text-center text-typography-500">
        {t('messages.newAccountNotice.body')}
      </Text>
    </VStack>
  );
}
